module.exports = __webpack_public_path__ + "img/machineLearning.c1f7f11d.png";